/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow, Icon, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { Box } from 'components/Box'

interface ConsultaSeguimentoIndicatorHelperProps {
  title: string
  subtitle: string
}

export const ConsultaSeguimentoIndicatorHelper = (props: Readonly<ConsultaSeguimentoIndicatorHelperProps>) => {
  const theme = useTheme()
  const styles = createStyles(theme)
  const { title, subtitle } = props

  return (
    <Box style={styles.box}>
      <HFlow alignItems='center' hSpacing={1}>
        <Icon size={2} icon='chatOutline' style={styles.icon} />
        <VFlow vSpacing={0}>
          <Text style={styles.label}>{title}</Text>
          <Text style={styles.text}>{subtitle}</Text>
        </VFlow>
      </HFlow>
    </Box>
  )
}

const createStyles = (theme: Theme) => ({
  box: css`
    padding: 0.5em;
  `,
  label: css`
    color: ${theme.pallete.primary.main};
    font-weight: bold;
  `,
  text: css`
    color: ${theme.pallete.text.main};
    font-weight: normal;
  `,
  icon: css`
    color: ${theme.pallete.primary.main};
  `,
})
